export const lasVegasParkingStyles = {
	header: {
		backgroundColor: '#bbb9b9',
	},
	sidebar: {
		backgroundColor: '#bbb9b9',
		color: '#000000 !important',
	},
	title: {
		color: '#000000 !important',
	},
	button: {
		backgroundColor: '#cb2026',
		color: '#ffffff !important',
		fontWeight: 600,
		':hover': {
			color: '#ffffff !important',
			backgroundColor: '#cb2026',
		},
	},
	text: {
		color: '#000000 !important',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#661013',
		headerTextColor: '#2d2d2d',
	},
	platformName: {
		name: 'Las Vegas Parking Platform',
	},
	logo: {
		small: {
			src: '/lasVegas/las-vegas-parking-icon.png',
			height: 50,
			width: 50,
		},
		large: {
			src: '/lasVegas/las-vegas-parking-logo.png',
			height: 70,
			width: 145,
		},
	},
	favicon: {
		src: '/lasVegas/las-vegas-parking-icon.png',
	},
	socials: {},
	siteUrl: 'https://lvparking.com/',
	orgName: 'Las Vegas Parking',
};
